import React from 'react';
import PropTypes from 'prop-types';
import { isNumber } from 'lodash';
import AgeDisplay from '../age-display';


function AgeRenderer(props) {
  const { value } = props;
  if (props.node.group) {
    // groupping
    return null;
  }
  let val = value;
  if (val === null || val === undefined) {
    return null;
  }
  if (!isNumber(val)) {
    val = Math.ceil(value.value); // b/c of average func
  }
  return (
    <div>
      <AgeDisplay value={val} short />
    </div>
  );
}

AgeRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.number,
    }),
  ]),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
AgeRenderer.defaultProps = {
  value: null,
  node: null,
};

export default AgeRenderer;
